<div class="dialog-content-wrapper">
  <mat-toolbar matDialogTitle class="mat-accent m-0">
    <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
      <span class="title dialog-title">{{'privacy.preview' | translate}}</span>
      <button mat-button class="mat-icon-button"
        (click)="dialogRef.close()"
        aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  <div mat-dialog-content class="p-24 m-0" fusePerfectScrollbar>
    <div [innerHTML]="editorContent">
    </div>
    @for (item of rules; track item) {
      <div>
        @if (item.active) {
          <mat-checkbox disabled="true">{{item.name}}</mat-checkbox>
        }
        @if (item.active) {
          <p>{{item.text}}</p>
        }
      </div>
    }
  </div>
</div>
